export default __webpack_public_path__ + "static/media/cablegreen.8246fe00.png";